<template>
  <div>
    <div class="white-background list-top-margin">
      <!-- 面包屑导航 -->
      <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">基础数据</el-breadcrumb-item>
          <el-breadcrumb-item>
            <span @click="goBack" class="cursor-pointer">工序</span>
            </el-breadcrumb-item>
          <el-breadcrumb-item>{{title}}</el-breadcrumb-item>
      </el-breadcrumb>
      <el-form :model="form" class="user-search" label-width="108px" size="small" :rules="rules" ref="form">
        <el-row>
          <el-col :span="8">
            <el-form-item label="工序编号">
              <el-input size="small" v-model="form.processCode" placeholder=" 请输入，忽略将自动生成" :readonly="mode == 'edit'" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="工序名称" prop="processName">
              <el-input size="small" v-model="form.processName" placeholder=" 请输入" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="报工权限" prop="userIdList">
              <el-select v-model="form.userIdList" filterable multiple placeholder="查找或添加新产品" class="full-width" clearable>
                <el-option
                  v-for="item in workAuthList"
                  :key="item.value"
                  :label="item.label + '('+item.phoneNum+')'"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="报工数配比" prop="coefficient">
              <el-input-number
                    size="small"
                    class="full-width"
                    v-model="form.coefficient"
                    controls-position="right"
                    :min="1"
                    :max="10"
                  ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="不良品项列表" prop="nongoodIdList">
              <el-select v-model="form.nongoodIdList" filterable multiple placeholder="请选择" class="full-width" clearable>
                <el-option
                  v-for="item in nongoodList"
                  :key="item._id"
                  :label="item.nongoodName"
                  :value="item._id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>


          <!-- <el-col :span="8">
            <el-form-item label="技术要求">
              <el-input size="small" v-model="form.noData" placeholder="请填写" clearable></el-input>
            </el-form-item>
          </el-col>-->
          <!-- <el-col :span="24">
            <el-form-item label="工序采集数据">
              <list-table ref="listTable" :formData="form"></list-table>
            </el-form-item>
          </el-col> -->
        </el-row>
        <FormItem :setList="setList" :form="form" :colSpan="8" :mode="mode" v-if="showChild"></FormItem>
      </el-form>
      <div class="text-align-center">
        <el-button size="small" @click="cancel">取 消</el-button>
        <el-button size="small" type="primary"  @click="save()" v-if="!disabled">保 存</el-button>
      </div>
    </div>
    <!-- 添加工序弹窗 -->
    <el-dialog title="添加工序" :visible.sync="dialog.visible && dialog.mode == 'productProgress'" width="50%" @close="closeProductProgress" :close-on-click-modal="false">
      <production-processes v-if="dialog.visible && dialog.mode == 'productProgress'" @done="closeProductProgress"></production-processes>
    </el-dialog>
    <!-- 从模板中添加弹窗 -->
    <el-dialog title="从模板中添加" :visible.sync="dialog.visible && dialog.mode == 'templete'" width="30%" @close="closeTemplete" :close-on-click-modal="false">
      <templete-dialog v-if="dialog.visible && dialog.mode == 'templete'" @done="closeTemplete"></templete-dialog>
    </el-dialog>
    <!-- 保存为模板 -->
    <el-dialog title="保存为模板" :visible.sync="dialog.visible && dialog.mode == 'saveTemplete'" width="30%" @close="closeSaveTemplete" :close-on-click-modal="false">
      <save-templete v-if="dialog.visible && dialog.mode == 'saveTemplete'" @done="closeSaveTemplete"></save-templete>
    </el-dialog>
  </div>
</template>
<script>
import { queryAllUserList} from '@/api/business';
import { getAll,processSave } from '@/api/basicData'
import ListTable from '@/views/basicData/workProcedure/list-table.vue'
import ProductionProcesses from "@/views/order/dialogManage/production-processes.vue";
import TempleteDialog from "@/views/order/dialogManage/templete-dialog.vue";
import SaveTemplete from "@/views/order/dialogManage/save-templete.vue";
import FormItem from "@/components/FormItem";
export default {
  props:['mode','userData','editRow','setList'],
  components: {
    ListTable,
    ProductionProcesses,
    TempleteDialog,
    SaveTemplete,
    FormItem
  },

  data() {
    return {
      disabled:false,
      form:{
        processName:'',
        userIdList:[],
        nongoodIdList:[],
        // check:'关闭',
      },
      rules:{
        processName: [{
            required: true,
            message: "请输入工序名称",
            trigger: ['blur','change'],
        },] ,
        userIdList: [{
            required: true,
            message: "请选择报工权限",
            trigger: ['change'],
        },] ,
        coefficient: [{
            required: true,
            message: "请输入报工数配比",
            trigger: ['blur','change'],
        },] ,
        nongoodIdList: [{
            required: true,
            message: "请选择不良品项列表",
            trigger: ['change'],
        },] ,
      },
      nongoodList: [],
      customerOptions: [{
        value: '重要客户',
        label: '重要客户'
      }, {
        value: '一般客户',
        label: '一般客户'
      }, {
        value: '新客户',
        label: '新客户'
      }],
      weChatNotification: [{
        value: '是',
        label: '是'
      }, {
        value: '否',
        label: '否'
      }],
      checkOptions: [{
        value: '关闭',
        label: '关闭'
      }, {
        value: '开启',
        label: '开启'
      }],
      imageUrl:'',
      dialog:{
        visible:false,
        mode:''
      },
      workAuthList: [],
      showChild:true,
      title:'创建工序'
    }
  },
  created(){
    this.showChild = true;
    this.init()
    this.getNongoodList()
    if(this.mode == 'view'){
      this.disabled = true
    }else if(this.mode == 'edit'){
      this.title = '编辑工序';
      this.form = JSON.parse(JSON.stringify(this.editRow));
    }
  },
  methods: {
    async init(){
      var res = await queryAllUserList(this.userData.factoryId);
      if(res['code'] == 200){
        this.workAuthList = res.data.map(function(item){
            return {
              label:item.name ? item.name : '',
              value:item._id,
              phoneNum:item.phoneNum,
            }
        });
      }
    },
    getNongoodList(){
      getAll(this.userData.factoryId).then(res => {
        if(res.code == 200){
          this.nongoodList = res.data
        }else{
          this.$message.error('查询失败！')
        }
        this.loading = false
      })
      .catch(err => {
        this.loading = false
        this.$message.error(err)
      })
    },
    cancel:function(){
      this.showChild = false;
      this.$emit('done',{type:'cancel'})
    },
    save:function(){
      this.$refs.form.validate((valid) => {
          if (valid) {
            var data = JSON.parse(JSON.stringify(this.form))
            // data.dataList = this.$refs.listTable.listData
            data.factoryId = this.userData.factoryId,
            processSave(data).then(res => {
              if(res.code == 200){
                this.$message.success('保存成功')
                this.showChild = false;
                this.$emit('done',{type:'save'})
              }else{
                this.$message.error(res.msg)
              }
            }).catch(err => {
              this.$message.error(err)
            })
          }
      })
    },
    add(){},
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isJPG && isLt2M;
    },
    closeProductProgress(){
      this.colseCommon()
    },
    showDialog:function(options){
      this.dialog.visible = true
      this.dialog.mode = options
    },
    closeTemplete(){
      this.colseCommon()
    },
    closeSaveTemplete(){
      this.colseCommon()
    },
    colseCommon(){
      this.dialog.visible = false
      this.dialog.mode = ''
    },
    showMenu(){
      this.$nextTick(_ => { this.$refs.selectChoose.toggleMenu(); });
    },
    clearCustomer(){
      this.form.customerType = ''
    },
    goBack(){
      this.showChild = false;
      this.$emit("goBack");
    },
  },
}
</script>
<style scoped>

.normal-half-width{
  width: calc(100% - 132px);
  margin-left: 8px;
}
.fold-botton{
  font-size: 14px;
  color: #1890ff;
  margin-right: 12px;
  cursor: pointer;
}

.small-title{
  font-size: 14px;
  margin: 30px 0;
}
.self-select-box{
  display: inline-block;
  /* margin: 4px 0; */
  padding: 0 4px;
  width: 80px;
  text-align: center;
  border-radius: 5px;
}
.custumer-type .default-people,
.default-people{
  color: #606266;
  background-color:#F4F4F5;
}
.custumer-type .el-select-dropdown__item{
  height: 28px;
  line-height: 28px;
  margin: 5px 0;
}
.custumer-type .el-select-dropdown__item.selected{
  color: #606266;
  font-weight: normal;
  background-color: #ECF5FF;
}
.custumer-type .common-people,
.common-people{
  color: rgb(61, 210, 126);
  background-color: rgb(233, 247, 239);
}
.custumer-type .important-people,
.important-people{
  color: rgb(255, 89, 80);
  background-color: rgb(249, 234, 233);
}
.choose-title{
    display: inline-block;
    width: 80px;
    position: absolute;
    z-index: 1000;
    left: 15px;
    top: 6px;
    height: 24px;
    line-height: 24px;
    border-radius: 5px;
    text-align: center;
    cursor: pointer;
}
.efdault-value-box{
  display: inline-block;
  border: 1px solid #DCDFE6;
  /* width: calc(100% - 80px); */
  width: 100%;
  height: 30px;
  border-radius: 4px;
  cursor: pointer;
}
.efdault-value-box .fx{
  padding-left: 15px;
  color: #02b980;
  font-style:italic;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/views/basicData/workProcedure/CreateLayout.vue